<template>
  <qc-container title="轮播图管理">
    <page-request ref="table" url="/api/mgr/business/shop/banner/list" :table-header="tableHeader" :expend="expend" :prop="{type:type}" :op-width="200">
      <t-button @click="doEdit()">添加</t-button>
      <template #op="scope">
        <b-button @click="doEdit(scope.row)">编辑</b-button>
        <b-button v-if="scope.row.status==0" @click="setStatus(scope.row,1)">上架</b-button>
        <b-button v-if="scope.row.status==1" @click="setStatus(scope.row,0)">下架</b-button>
        <b-button @click="doDel(scope.row.id)">删除</b-button>
      </template>
    </page-request>
  </qc-container>

</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";

export default {
  name: "banner",
  components: {PageRequest, TButton, BButton, QcContainer},
  data() {
    return {
      type:"0",
      tableHeader: [
        {prop: "name", label: "名称",minWidth:160},
        {prop: "pic",type:"image", label: "图片",minWidth:300,imgWidth:142,imgHeight:56},
        {label: "展示位置",width:120,renderDraw:row=>{
            return ['商城','租售'][row.type];
          }},
        {prop: "sort", label: "排序",width:100},
        {prop: "statusDesc", label: "状态",width:100},
        {prop: "createTime", label: "创建时间",width:160},
      ],
      expend: [
        {label: "名称", prop: "name"},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    doEdit(row) {
      this.toRouter("/index/content/banner/add",row?{id:row.id}:null);
    },
    setStatus(row,type){
      let obj = this.copyObj(row);
      obj.status = type;
      this.simplePost("/api/mgr/business/shop/banner/addOrUpdate",obj,()=>{
        this.pageReloadData();
      });
    },
    doDel(id) {
      this.msgConfirm("/api/mgr/business/shop/banner/delete", {id: id}, () => {
        this.pageReloadData();
      });
    },
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
